import { FC, useEffect, useState } from 'react';
import { ComponentRendering, Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';
import isEmpty from 'lodash-es/isEmpty';

import { ComponentProps } from '@gn-audio/jss-components';

import { usePathMatch } from 'composables/shared/usePathMatch';

type TopWarningMessageRendering = {
  fields: TopWarningMessageFields;
};
type TopWarningMessageFields = {
  message?: Field<string>;
  whitelistPaths?: Field<string>;
  isActive?: Field<boolean>;
};
type TopWarningMessageProps = {
  rendering: TopWarningMessageRendering & ComponentRendering;
  showWarning: boolean;
} & ComponentProps;

export const TopWarningMessage: FC<TopWarningMessageProps> = ({ rendering }) => {
  const { isCurrentPathMatched } = usePathMatch();
  const [mounted, setMounted] = useState(false);
  const data = rendering.fields;

  useEffect(() => {
    setMounted(true);
  }, []);

  const isOnWhiteList = mounted ? isCurrentPathMatched(data.whitelistPaths?.value) : false;
  const showWarning = isOnWhiteList && data?.isActive?.value;

  if (!showWarning) return null;

  const hasMessage = data.message && !isEmpty(data.message.value);
  if (!hasMessage) return null;
  const cleanHTMLMessage = sanitize(data.message?.value ?? '');
  return (
    <div className="bg-primary">
      <div
        className="container px-0 py-1 text-center text-on-brand"
        dangerouslySetInnerHTML={{ __html: cleanHTMLMessage }}
      />
    </div>
  );
};

export default withDatasourceCheck()<TopWarningMessageProps>(TopWarningMessage);
